import { useState } from "react";
import { observer } from "mobx-react";
import {Carousel} from "react-bootstrap";
import {useParams} from "react-router-dom";
import CategoriasBreadcrumbs from "./CategoriasBreadcrumbs";
import productosStore from "../stores/ProductosStore";
import {currencyFormat} from "../utils/utils";
import {cdnURL} from "../utils/api";
import carritoStore from "../stores/CarritoStore";
import { ShowCarrito } from "./Carrito";
import { NoIVA } from "./Footer";
import globals from "../globals";

function ProductoDescripcion() {
    const [cant, setCant] = useState({});
    const { prodId, prodName } = useParams();
    const fotos = [];

    const setCantExtended = (qty, talle, id) => {
        const newCant = {...cant};
        newCant[id] = { ...newCant[id], [talle]: qty };
        setCant(newCant);
    }

    if (productosStore.cargando) {
        return (
            <div className="row cargando-categorias text-center producto-detalle">
                <div className="col-12 px-0">
                    <p><i className='fa-solid fa-spinner'/> Cargando {prodName}... </p>
                </div>
            </div>
        );
    }
    if (!productosStore.producto || productosStore.producto.id.toString() !== prodId.toString())
        productosStore.prodById(prodId);
    const prod = productosStore.producto;
    if (!prod) {
        return (
            <div className="row cargando-categorias text-center producto-detalle">
                <div className="col-12 px-0">
                    <p><i className='fa-solid fa-spinner'/> Cargando {prodName}... </p>
                </div>
            </div>
        );
    }
    if (prod.image1) fotos.push(prod.image1);
    if (prod.image2) fotos.push(prod.image2);
    if (prod.image3) fotos.push(prod.image3);
    if (fotos.length === 0)
        fotos.push(undefined)
    const variantesConStock = (prod.variantes || []).filter(v => v.stock_total > 0);
    return (
        <div className="container my-5 producto-detalle">
            <div className="row d-flex justify-content-center">
                <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
                    <CategoriasBreadcrumbs noTodos volver familia={prod.family_name}/>
                </div>
            </div>

            <div className="row d-flex justify-content-center detalle-producto">
                <div className="col-xl-5 col-lg-8 col-md-6 col-sm-12 col-12">
                    <Carousel interval={2500}>
                        {fotos.length > 0 &&
                            <Carousel.Item>
                                <img alt='' src={cdnURL(fotos[0], '/img/prod_default.png')} className="d-block h-max-prod" />
                            </Carousel.Item>
                        }
                        {fotos.length > 1 &&
                            <Carousel.Item>
                                <img alt='' src={cdnURL(fotos[1], '/img/prod_default.png')} className="d-block h-max-prod" />
                            </Carousel.Item>
                        }
                        {fotos.length > 2 &&
                            <Carousel.Item>
                                <img alt='' src={cdnURL(fotos[2], '/img/prod_default.png')} className="d-block h-max-prod" />
                            </Carousel.Item>
                        }
                    </Carousel>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 ">
                    <div className="d-flex flex-column info-producto h-100">

                        <h3 className="nombre-producto">{prod.name}</h3>
                        { prod.sale_price_pes >= 0 &&
                            <h5 className="precio">{currencyFormat(prod.sale_price_pes)}</h5>
                        }

                        <p className="descripcion mt-4">
                            {prod.original_product_id &&
                                <strong>
                                    {prod.original_product_id}
                                    <br />
                                </strong>
                            }
                            {prod.brand &&
                                <>
                                <strong> MARCA: </strong> {prod.brand}<br />
                                </>
                            }
                        </p>
                        <p className="descripcion mt-4">{prod.description}</p>

                        {!globals.soloCatalogo && variantesConStock.length === 0 &&
                            <div className={'agregar-carrito-cant text-center'}
                                 style={{fontSize: '14px', padding: '12px', marginTop: '10px', fontWeight: '600'}}>
                                AGOTADO
                            </div>
                        }
                        {!globals.soloCatalogo &&
                         variantesConStock.map(v => (
                            <div className={'row'} key={v.id} style={{ marginBottom: '12px' }}>
                                <div className={'col-12'} style={{ paddingTop: '5px', fontWeight: '600', marginBottom: '5px' }}>
                                    COLOR: { (v.variante || v.variante_desc || '').toUpperCase() }
                                </div>
                                <p style={{fontSize: '12px', marginBottom: '9px', opacity: 1}}>
                                    Poné la cantidad por talle que querés y apretá &quot;Agregar al Carrito&quot;.
                                </p>
                                <div className={'row'} style={{fontSize: '10px'}}>
                                { Object.keys(v.stock[globals['FILTRO_DEPOSITO']].inventory_level_extended).map(t => {
                                    let stock = parseInt(v.stock[globals.FILTRO_DEPOSITO].inventory_level_extended[t].stock) 
                                    let enCarrito = carritoStore.carrito.filter(p => p.id == v.id).reduce((a, b) => a + b.quantity_extended[t], 0);
                                    if (isNaN(enCarrito)) enCarrito = 0;
                                    let disponibles = stock - enCarrito;

                                   return (
                                    <div className={'col-3 d-flex flex-column justify-content-end'} key={t}>
                                        { enCarrito > 0 &&
                                            <div className={'text-center'} style={{fontSize: '12px', marginTop: '15px', whiteSpace: 'nowrap'}}>
                                                <b>EN CARRITO:</b> {enCarrito}
                                            </div>
                                        }
                                        <div className={'text-center'} style={{fontSize: '12px', whiteSpace: 'nowrap'}}> <b>TALLE:</b> {t} </div>
                                        <div className={'text-center'} style={{fontSize: '12px', whiteSpace: 'nowrap'}}> <b>STOCK:</b> {stock} </div>
                                    { disponibles <= 0 
                                    ? <div className={'agregar-carrito-cant text-center'} 
                                        style={{fontSize: '8px', padding: '8px', marginTop: '5px'}}> SIN STOCK </div>
                                    : <input
                                        style={{marginTop: '5px', padding: '0'}}
                                        className={'agregar-carrito-cant text-center'}
                                        type={'number'}
                                        step={1}
                                        min={0}
                                        max={disponibles}
                                        value={cant[v.id] && cant[v.id][t] ? cant[v.id][t] : 0}
                                        onChange={e => setCantExtended(parseInt(e.target.value), t, v.id)}
                                    />
                                    }
                                    </div>
                                )})}
                                </div>
                                <div className={'col-12'} style={{marginTop: '10px'}}>
                                    <button className={'agregar-carrito'}
                                            disabled={!cant[v.id] || Object.values(cant[v.id]).every(q => !q || q <= 0)}
                                            onClick={() => {
                                                if (!cant[v.id] || Object.values(cant[v.id]).every(q => !q || q <= 0))
                                                    return;
                                                carritoStore.agregar(
                                                    {
                                                        id: v.id,
                                                        name: prod.name + ' - ' + (v.variante || v.variante_desc || '').toUpperCase(),
                                                        prod_id: prod.original_product_id,
                                                        brand: prod.brand,
                                                        price: prod.sale_price_pes,
                                                        imagen: prod.image1thumb || prod.image2thumb || prod.image3thumb,
                                                        max: v.stock[globals.FILTRO_DEPOSITO].inventory_level_extended
                                                    }, cant[v.id]);
                                                ShowCarrito();
                                            }}
                                    >Agregar al Carrito</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <NoIVA />
        </div>
    );
}
export default observer(ProductoDescripcion);
